import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';
import HomePage from './pages/HomePage.jsx';
import WasteSortingABCPage from './pages/WasteSortingABCPage.jsx';
import HowToSortPage from './pages/HowToSortPage.jsx';
import MythsAndFAQPage from './pages/MythsAndFAQPage.jsx';
import { Toaster } from '@/components/ui/sonner';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/rusiavimo-abc" element={<WasteSortingABCPage />} />
          <Route path="/kaip-rusiuoti" element={<HowToSortPage />} />
          <Route path="/mitai-ir-duk" element={<MythsAndFAQPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
